// components/EmailSubscription/EmailSubscription.jsx
import React, { useState } from 'react';
import './EmailSubscription.css';
import TrustedBySection from './TrustedBySection';
import featureFlags from '../../configuration/featureFlags';
import siteConfig from '../../configuration/siteConfiguration';

const EmailSubscription = (props) => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email) {
      const baseUrl = siteConfig.apiBaseUrl || 'http://localhost:8000';
      try {
        const response = await fetch(`${baseUrl}/leads/create`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: email,
            source_id: 'web.cognitva.ai',
            source_context: 'home',
          }),
        });
        if (response.ok) {
          setIsSubmitted(true);
        } else {
          // Optionally handle error here
          console.error('Failed to submit email:', response.statusText);
        }
      } catch (error) {
        console.error('Error submitting email:', error);
      }
    }
  };

  return (
    <>
      <div className="email-subscription">
        <div className="subscription-header">
          <h3 className="subscription-title">Connect with us to know more</h3>
        </div>

        {!isSubmitted ? (

          <form className="subscription-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="email-input"
                required
              />
              <button type="submit" className="submit-button">
                Submit
              </button>
            </div>
          </form>
        ) : (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <p>Thank you! You've been added to our waitlist.</p>
          </div>
        )}

        <p className="privacy-notice">
          We care about your data in our{' '}
          <a href="/terms-of-user" className="privacy-link">
            privacy policy
          </a>
        </p>
        <div className="down-arrow icon bounce">
          <img src="/images/arrowdown.svg" alt="Down Arrow" onClick={() => {
            if (props?.onJumpIconClick) {
              props.onJumpIconClick();
            }
          }} />
        </div>
      </div>
      {featureFlags.home.showTrustedCustomers &&
        <TrustedBySection />
      }
    </>
  );
};

export default EmailSubscription;